import React from 'react';
import './PageHeader.css';

export default function PageHeader({
  title,
  crumbs = [{ label: 'Home', href: '/' }],
  subtitle,
}) {
  return (
    <div className="full-bleed site-headerBand">
      {crumbs?.length > 0 && (
        <nav className="site-breadcrumb" aria-label="Breadcrumb">
          <ol>
            {crumbs.map((c, i) => {
              const isLast = i === crumbs.length - 1;

              return (
                <li key={i}>
                  {isLast || !c.href ? (
                    <span aria-current="page">{c.label}</span>
                  ) : (
                    <a href={c.href}>{c.label}</a>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}

      <h1 className="site-pageTitle">{title}</h1>
      {subtitle && <p className="site-pageSubtitle">{subtitle}</p>}
    </div>
  );
}
